import { Component, OnInit } from '@angular/core';
import { VssOrganizationsService } from '../vss-organizations.service';
import { faUserPlus, faSearchPlus, faEdit, faTrashAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import { VssOrganizationTable } from 'src/app/shared/models/vss-organization-table.model';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
    selector: 'app-vss-organizations',
    templateUrl: './vss-organizations.component.html',
    styleUrls: ['./vss-organizations.component.css'],
    standalone: false
})
export class VssOrganizationsComponent implements OnInit {

  public icons: { [name: string]: any } = {
    'faUserPlus': faUserPlus,
    'faSearchPlus': faSearchPlus,
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt,
    'faHeart': faHeart
  };
  public tableOgranizations: VssOrganizationTable[] = [];
  public currentLanguage: string;
  public loading = true;

  constructor(private _vssOrganizationsService: VssOrganizationsService, private _translateService: TranslateService,
    private _sharedService: SharedService) { }

  ngOnInit(): void {
    this.currentLanguage = this._translateService.getDefaultLang();
    this._sharedService.organizationNameSubject.next({});
    this._vssOrganizationsService.getSportCategories().subscribe(sportCats => {
      this._vssOrganizationsService.getVssOrganizations(sportCats).subscribe(result => {
        this.tableOgranizations = result;
        this.loading = false;
      });
    });
  }

}
